module.exports = __webpack_public_path__ + "static/media/Services-05.039e57c3.jpg";